import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  FORGOT_PASSWORD_CONFIRM_TOKEN_ROUTE_NAME,
  FORGOT_PASSWORD_DONE_ROUTE_NAME,
  FORGOT_PASSWORD_EMAIL_ROUTE_NAME,
  FORGOT_PASSWORD_ENTER_PASSWORD_ROUTE_NAME,
  TRANSLATION_GROUP_FORGOT_PASSWORD,
} from './constants';
import { getTranslationKeys } from './translations';

export class ForgotPasswordModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAnonymousRoute({
      name: FORGOT_PASSWORD_EMAIL_ROUTE_NAME,
      path: '/passwords/password_new',
      component: () => import('./pages/ForgotPasswordEnterEmailPage/ForgotPasswordEnterEmailPage.vue'),
    });

    router.addAnonymousRoute({
      name: FORGOT_PASSWORD_CONFIRM_TOKEN_ROUTE_NAME,
      path: '/passwords/confirm_email/:token?',
      component: () => import('./pages/ForgotPasswordConfirmPage/ForgotPasswordConfirmPage.vue'),
    });

    router.addAnonymousRoute({
      name: FORGOT_PASSWORD_ENTER_PASSWORD_ROUTE_NAME,
      path: '/passwords/change_password/:token',
      component: () => import('./pages/ForgotPasswordEnterPage/ForgotPasswordEnterPage.vue'),
    });

    router.addAnonymousRoute({
      name: FORGOT_PASSWORD_DONE_ROUTE_NAME,
      path: '/passwords/save_password/:token',
      component: () => import('./pages/ForgotPasswordDone/ForgotPasswordDone.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_FORGOT_PASSWORD, getTranslationKeys);
  }
}
